import React from "react";
import { TextInputProps } from "./types";
import { StyledTextInput } from "./styles";
import { Input } from "antd";

const TextInput: React.FC<TextInputProps> = ({ ...props }): JSX.Element => {
  return (
    <StyledTextInput>
      <Input {...props} />
    </StyledTextInput>
  );
};

export default TextInput;
